import { render, staticRenderFns } from "./UserNotification.vue?vue&type=template&id=8d5b59f4&scoped=true&"
import script from "./UserNotification.vue?vue&type=script&lang=js&"
export * from "./UserNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserNotification.vue?vue&type=style&index=0&id=8d5b59f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b59f4",
  null
  
)

export default component.exports